import { useEffect, useState } from "react";

import { publicEndpoints } from "../../../api";

// Local type definitions
interface CurrencyPairRate {
  rate: number;
  rate_date?: string;
  lastUpdate?: string;
}

interface CurrencyPairsMap {
  EURUSD?: CurrencyPairRate;
  GBPUSD?: CurrencyPairRate;
  [key: string]: CurrencyPairRate | undefined;
}

const defaultPairs: CurrencyPairsMap = {
  EURUSD: {
    rate: 0,
    rate_date: undefined,
    lastUpdate: undefined,
  },
  GBPUSD: {
    rate: 0,
    rate_date: undefined,
    lastUpdate: undefined,
  },
};

const useMarketCurrencyPairs = () => {
  const [pairs, setPairs] = useState<CurrencyPairsMap>(defaultPairs);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    publicEndpoints
      .getCurrencyPairs()
      .then(({ data }) => {
        setPairs(data || defaultPairs);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    currencyPairs: pairs,
    lastUpdate: pairs?.EURUSD?.lastUpdate,
    isLoading,
  };
};

export default useMarketCurrencyPairs;
